import type { FC } from "react";
import { type ISO8601_DATE, type ISO8601_TIME } from "../../../../../../../../utils/iso8601";
import {
  NextSends,
  type NextSendsProps,
} from "../../../../../../../schedule/components/next-sends";
import { usePreviewContext } from "../../preview-context";

export const PreviewDetailsSidebarSchedule: FC = () => {
  const {
    moment_preview_data: { immediate, timezone, schedule, event_key },
  } = usePreviewContext();

  const date = event_key?.date ?? null;

  const data: NextSendsProps = {
    immediate,
    timezone,
    event_calendar: event_key?.calendar ?? false,
    event_title: event_key?.title ?? null,
    event_number_of_repeats: event_key?.number_of_repeats ?? undefined,
    event_repeat: event_key?.repeat ?? null,
    event_date: date as ISO8601_DATE,
    event_key: event_key?.key ?? null,
    schedule_event_initial: schedule?.event_initial ?? false,
    schedule_event_repeat: schedule?.event_repeat ?? null,
    schedule_interval_json: schedule?.interval_json ?? null,
    schedule_on_event_key: schedule?.on_event_key ?? null,
    schedule_send_at: schedule?.send_at ?? ("12:00" as ISO8601_TIME),
    isSurveyCompleted: !immediate && !schedule,
  };

  return <NextSends {...data} />;
};
